import { useState } from 'react';
const AUTOCOMPLETE_STORAGE_KEY = 'strata:editor_autocomplete';
function useAutocomplete() {
    const [autocompleteEnabled, setAutocomplete] = useState(() => {
        const storedValue = localStorage.getItem(AUTOCOMPLETE_STORAGE_KEY);
        const initialState = storedValue ? JSON.parse(storedValue) : null;
        return typeof initialState === 'boolean' ? initialState : false;
    });
    const toggleAutocomplete = () => {
        const newState = !autocompleteEnabled;
        setAutocomplete(newState);
        localStorage.setItem(AUTOCOMPLETE_STORAGE_KEY, JSON.stringify(newState));
    };
    return { autocompleteEnabled, toggleAutocomplete };
}
export default useAutocomplete;
//# sourceMappingURL=useAutocomplete.js.map